import { createStore, combineReducers, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import { composeWithDevTools } from 'redux-devtools-extension';
import FilledQuestionnaireReducer from './reducers/filled-questionnaire-reducer';
import QuestionnaireReducer from './reducers/questionnaire-reducer';

const rootReducer = combineReducers({
  questionnaire: QuestionnaireReducer,
  filledQuestionnaire: FilledQuestionnaireReducer,
});

export type RootState = ReturnType<typeof rootReducer>;

const middleware = [thunk];

export const store = createStore(
  rootReducer,
  composeWithDevTools(applyMiddleware(...middleware))
);